const vueVersion = function (o) {
    try {
        var e = (o.version || "").split(".");
        if (0 < e.length)
            return Number(e[0]);
    }
    catch (o) { }
    return 2;
};
function formatComponentInfo(o, e, t) {
    if ("vm" === o.$root)
        return "<Root>";
    var n = 3 === t ? o.$options || o.constructor.options || {} : "function" == typeof o && null != o.cid ? o.options : o._isVue ? o.$options || o.constructor.options : o || {}, t = n.name || n._componentTag, o = n.__file;
    return ((t = !t && o ? (n = o.match(/([^/\\] + )\.vue$ /)) && n[1] : t) ? "component: <" + t.replace(/(?:^|[-_])(\w)/g, function (o) {
        return o.toUpperCase();
    }).replace(/[-_]/g, "") + ">" : "<Anonymous>") + (o && !1 !== e ? " file path: " + o : "");
}
export default function vuePlugin(wpk, Vue) {
    const _oldOnError = Vue.config.errorHandler;
    Vue.config.errorHandler = function VueErrorHandler(error, vm, info) {
        wpk.reportError(error, {
            c1: formatComponentInfo(vm, !0, vueVersion(vm)),
            c2: info
        });
        console.error(error);
        if (typeof _oldOnError === 'function') {
            _oldOnError.call(this, error, vm, info);
        }
    };
}
